var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsBuilder = function SvgFormsBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 4.163h41.666V45.83H4.167V4.163zM37.5 12.496h-8.333M37.5 20.83H26.389M37.5 29.163H26.389M34.722 37.496H26.39",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.496h8.333v8.333H12.5v-8.333zM12.5 29.163h8.333v8.333H12.5v-8.333z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsBuilder;